import {
    BORDER_COLORS as BC,
    ICON_COLORS as IC,
    ROOT_TOKENS_COLORS as RTC,
    SURFACE_COLORS as SC,
    TEXT_COLORS as TC,
} from '@constants/colors.ts';
import { DESKTOP_SIZES, FONT_FAMILY, SIZES } from '@constants/fonts.ts';
import styled from 'styled-components';

import { Name as StyledName, Role as StyledRole } from '../___shared___/styled.tsx';

export const APP_VERSION_MENU_ITEM_ID = 'app-version-menu-item';

export const ProfileMenuWrapper = styled.div`
    border-radius: 8px;
    border: 1px solid ${SC.disabled};
    box-shadow: 0 0 5.9px 0 rgba(94, 99, 117, 0.2);
    background: ${RTC.white.default};
`;

export const Name = styled(StyledName)`
    ${DESKTOP_SIZES[SIZES.BODY_MD].fontSize}
`;

export const Role = styled(StyledRole)``;

export const InfoSection = styled.div`
    padding: 16px;
    background: ${SC.neutral};
    display: flex;
    align-items: center;
    gap: 16px;
    user-select: none;
`;

export const InfoWrapper = styled.div`
    display: flex;
    flex-direction: column;
`;

export const LinksSection = styled.div`
    padding: 10px 0;

    [id=${APP_VERSION_MENU_ITEM_ID}] {
        align-items: center;
    }
`;

export const LinkItem = styled.div`
    user-select: none;
    color: ${SC.actionHover};
    ${FONT_FAMILY.poppins};
    ${DESKTOP_SIZES[SIZES.BODY_SM].fontSize}
    ${DESKTOP_SIZES[SIZES.BODY_MD_MED].fontWeight};
    ${DESKTOP_SIZES[SIZES.BODY_SM].lineHeight}
    display: flex;
    gap: 16px;
    padding: 16px 24px;

    &:hover {
        background: ${SC.page};
        cursor: pointer;
    }

    &:last-child {
        color: ${TC.error};
        border-top: 1px solid ${BC.separator};
    }
`;

export const LinkItemIcon = styled.div`
    img {
        width: 16px;
        height: 16px;
        color: ${IC.primary};
    }
`;

export const LinkItemName = styled.div`
    ${DESKTOP_SIZES[SIZES.BODY_XS].lineHeight}
`;

export const Avatar = styled.div`
    display: flex;
    img {
        border-radius: 50%;
        width: 72px;
        height: 72px;
    }
`;
